import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, RivenditoriDocument, RegioniDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { RivenditoriTemplate } from '@components/templates'

const RivenditoriPage = ({ pagina, rivenditori, regioni }) => (
  <RivenditoriTemplate pagina={pagina} rivenditori={rivenditori} items={regioni} />
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'rivenditori', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { rivenditori },
    } = await client.query({
      query: RivenditoriDocument,
    })

    const {
      data: { regioni },
    } = await client.query({
      query: RegioniDocument,
    })

    return {
      props: { pagina, rivenditori, regioni },
      revalidate: 60 * 20,
    }
  },
  '/rivenditori'
)

export default RivenditoriPage
